import React, { useEffect, useState } from "react";
import { db } from "../FirebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { FaCrown, FaFacebook, FaLinkedin, FaStar } from "react-icons/fa";
import { FaUpwork } from "react-icons/fa6";
import { RiArrowRightUpLine } from "react-icons/ri";
import { TbBrandFiverr } from "react-icons/tb";

export const getFlagEmoji = (region) => {
  const match = region.match(
    /🇦🇫|🇦🇱|🇩🇿|🇦🇩|🇦🇴|🇦🇬|🇦🇷|🇦🇲|🇦🇺|🇦🇹|🇦🇿|🇧🇸|🇧🇭|🇧🇩|🇧🇧|🇧🇾|🇧🇪|🇧🇿|🇧🇯|🇧🇹|🇧🇴|🇧🇦|🇧🇼|🇧🇷|🇧🇳|🇧🇬|🇧🇫|🇧🇮|🇨🇻|🇰🇭|🇨🇲|🇨🇦|🇨🇫|🇹🇩|🇨🇱|🇨🇳|🇨🇴|🇰🇲|🇨🇩|🇨🇬|🇨🇷|🇭🇷|🇨🇺|🇨🇾|🇨🇿|🇩🇰|🇩🇯|🇩🇲|🇩🇴|🇪🇨|🇪🇬|🇸🇻|🇬🇶|🇪🇷|🇪🇪|🇸🇿|🇪🇹|🇫🇯|🇫🇮|🇫🇷|🇬🇦|🇬🇲|🇬🇪|🇩🇪|🇬🇭|🇬🇷|🇬🇩|🇬🇹|🇬🇳|🇬🇼|🇬🇾|🇭🇹|🇭🇳|🇭🇺|🇮🇸|🇮🇳|🇮🇩|🇮🇷|🇮🇶|🇮🇪|🇮🇱|🇮🇹|🇯🇲|🇯🇵|🇯🇴|🇰🇿|🇰🇪|🇰🇮|🇰🇵|🇰🇷|🇰🇼|🇰🇬|🇱🇦|🇱🇻|🇱🇧|🇱🇸|🇱🇷|🇱🇾|🇱🇮|🇱🇹|🇱🇺|🇲🇬|🇲🇼|🇲🇾|🇲🇻|🇲🇱|🇲🇹|🇲🇭|🇲🇷|🇲🇺|🇲🇽|🇫🇲|🇲🇩|🇲🇨|🇲🇳|🇲🇪|🇲🇦|🇲🇿|🇲🇲|🇳🇦|🇳🇷|🇳🇵|🇳🇱|🇳🇿|🇳🇮|🇳🇪|🇳🇬|🇲🇰|🇳🇴|🇴🇲|🇵🇰|🇵🇼|🇵🇸|🇵🇦|🇵🇬|🇵🇾|🇵🇪|🇵🇭|🇵🇱|🇵🇹|🇶🇦|🇷🇴|🇷🇺|🇷🇼|🇰🇳|🇱🇨|🇻🇨|🇼🇸|🇸🇲|🇸🇹|🇸🇦|🇸🇳|🇷🇸|🇸🇨|🇸🇱|🇸🇬|🇸🇰|🇸🇮|🇸🇧|🇸🇴|🇿🇦|🇸🇸|🇪🇸|🇱🇰|🇸🇩|🇸🇷|🇸🇪|🇨🇭|🇸🇾|🇹🇼|🇹🇯|🇹🇿|🇹🇭|🇹🇱|🇹🇬|🇹🇴|🇹🇹|🇹🇳|🇹🇷|🇹🇲|🇹🇻|🇺🇬|🇺🇦|🇦🇪|🇬🇧|🇺🇸|🇺🇾|🇺🇿|🇻🇺|🇻🇦|🇻🇪|🇻🇳|🇾🇪|🇿🇲|🇿🇼/
  );
  return match ? match[0] : "🌍"; // Default globe emoji if no flag found
};

const FreelancersComponent = () => {
  const [freelancers, setFreelancers] = useState([]);
  const [loading, setLoading] = useState(true);

  // Fetch freelancers data from Firestore
  useEffect(() => {
    const fetchFreelancers = async () => {
      try {
        setLoading(true);
        const querySnapshot = await getDocs(collection(db, "freelancer"));
        const freelancersData = querySnapshot.docs
          .map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }))
          .filter((freelancer) => freelancer.status === "approved");
        setFreelancers(freelancersData);
      } catch (error) {
        console.error("Error fetching freelancers: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFreelancers();
  }, []);

  const generateWhatsAppLink = (freelancerName) => {
    const phoneNumber = "+923204192824";
    const message = `Hi Anum, I want to Hire ${freelancerName}`;
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    return url;
  };

  return (
    <>
      <Header />
      <section className="relative flex justify-center items-center bg-gradient-to-r from-black to-logo text-white md:py-24 py-12 w-full overflow-hidden">
        <div className="flex flex-col justify-center items-center text-center">
          <h2 className="md:text-5xl text-2xl font-bold animate-fadeIn">
            Tech Talent Program
          </h2>
          <p className="md:w-[70%] p-3">
            AS - Tech Talent Program is launched to present skillful individuals
            in the Tech Industry. Explore Profiles of Global Tech -
            Professionals ready to be hired for the jobs & Projects.
          </p>
        </div>
      </section>
      <div className="relative container w-full mx-auto md:px-24 md:mb-0 mb-32 px-6 md:py-6 py-3">
        {loading ? (
          <div className="grid md:grid-cols-3 grid-cols-1 gap-6 mt-8">
            {Array(3)
              .fill()
              .map((_, index) => (
                <div
                  key={index}
                  className="border-2 rounded-lg shadow-xl p-4 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 flex flex-col"
                >
                  {/* Skeleton Flag Emoji */}
                  <div className="absolute top-2 right-[26%] w-10 h-10 transform rounded-full -translate-x-1/2 shadow-md bg-gray-300 animate-pulse"></div>
                  {/* Skeleton Avatar */}
                  <div className="skeleton-avatar mb-4 w-24 h-24 mx-auto rounded-full bg-gray-300 animate-pulse"></div>
                  {/* Skeleton Name */}
                  <div className="skeleton-text mb-3 w-4/5 mx-auto h-5 bg-gray-300 animate-pulse"></div>
                  {/* Skeleton Expertise */}
                  <div className="skeleton-text mb-3 w-3/5 mx-auto h-5 bg-gray-300 animate-pulse"></div>
                  {/* Skeleton Rating */}
                  <div className="flex justify-center items-center py-2 gap-1">
                    <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
                    <div className="w-5 h-5 bg-gray-300 rounded-full animate-pulse"></div>
                  </div>
                  {/* Skeleton About */}
                  <div className="skeleton-text mb-2 w-full mx-auto h-16 bg-gray-300 animate-pulse"></div>
                  {/* Skeleton Portfolio and Social Links */}
                  <div className="flex justify-between mb-4">
                    <div className="skeleton-text w-20 h-4 bg-gray-300 animate-pulse"></div>
                    <div className="flex gap-3">
                      <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
                      <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
                      <div className="w-5 h-5 bg-gray-300 rounded animate-pulse"></div>
                    </div>
                  </div>
                  {/* Skeleton View More Button */}
                  <div className="skeleton-text w-full h-10 mx-auto bg-gray-300 rounded-full animate-pulse mt-auto"></div>
                </div>
              ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-3 grid-cols-1 gap-6 mt-8">
            {freelancers.map((freelancer, index) => (
              <div
                key={index}
                className="border-2 border-logo rounded-lg shadow-xl p-4 text-center transition-all duration-500 ease-in-out transform hover:-translate-y-2 flex flex-col"
              >
                {freelancer.applyForInterview === "pass" && (
                  <div className="absolute top-2 right-2 bg-gradient-to-r from-orange-500 to-red-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg uppercase z-10 flex items-center gap-1">
                    <FaCrown className="text-white" /> Featured
                  </div>
                )}
                <Link to={`/freelancer/${freelancer.id}`} className="flex flex-col flex-grow">
                  <div className="absolute top-2 right-[26%] w-10 h-10 transform rounded-full -translate-x-1/2 shadow-md">
                    <span className="text-2xl pt-[7px] flex justify-center items-center">
                      {getFlagEmoji(freelancer.region)}
                    </span>
                  </div>
                  <img
                    src={freelancer.pictureUrl}
                    alt={freelancer.name}
                    className="rounded-full mx-auto w-24 h-24 mb-4 object-cover"
                  />
                  <h3 className="text-lg font-bold text-center">
                    {freelancer.name}
                  </h3>
                  <h3 className="text-lg text-center">
                    {freelancer.expertise}
                  </h3>
                  <div className="flex justify-center items-center py-2 gap-1">
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                    <FaStar className="text-yellow-400" />
                  </div>
                  <h3 className="text-lg font-medium mb-2 text-start min-h-[5rem]">
                    {freelancer.about.length > 80
                      ? `${freelancer.about.slice(0, 80)}...`
                      : freelancer.about}
                  </h3>
                  <div className="flex justify-between mb-4">
                    <Link
                      to={freelancer.portfolio}
                      className="text-logo flex gap-1 items-center"
                    >
                      Portfolio <RiArrowRightUpLine />
                    </Link>
                    <div className="flex gap-3">
                      {freelancer.socialLinks?.linkedin && (
                        <Link
                          to={freelancer.socialLinks.linkedin}
                          className="text-blue-500"
                        >
                          <FaLinkedin size={20} />
                        </Link>
                      )}
                      {freelancer.socialLinks?.upwork && (
                        <Link
                          to={freelancer.socialLinks.upwork}
                          className="text-green-500"
                        >
                          <FaUpwork size={20} />
                        </Link>
                      )}
                      {freelancer.socialLinks?.facebook && (
                        <Link
                          to={freelancer.socialLinks.facebook}
                          className="text-logo"
                        >
                          <FaFacebook size={20} />
                        </Link>
                      )}
                      {freelancer.socialLinks?.fiverr && (
                        <Link
                          to={freelancer.socialLinks.fiverr}
                          className="text-green-500"
                        >
                          <TbBrandFiverr size={20} />
                        </Link>
                      )}
                    </div>
                  </div>
                  <button className="w-full bg-gradient-to-r from-orange-500 to-red-500 text-white py-2 px-6 rounded-full font-semibold shadow-lg mt-auto">
                    View More
                  </button>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default FreelancersComponent;